<form [formGroup]="form">
  <div class="row">
    <div class="col-6">
      <mat-form-field appearance="outline">
        <mat-label>{{ Texts.names }}</mat-label>
        <input type="text" formControlName="names" matInput placeholder="" />
      </mat-form-field>
    </div>
    <div class="col-6">
      <mat-form-field appearance="outline">
        <mat-label>{{ Texts.lastNames }}</mat-label>
        <input
          type="text"
          formControlName="lastNames"
          matInput
          placeholder=""
        />
      </mat-form-field>
    </div>
    <div class="col-4">
      <mat-form-field appearance="outline">
        <mat-label>{{ Texts.pasCi }} </mat-label>
        <mat-select formControlName="pasCi" disabled>
          <mat-option
            (click)="changeNacionali()"
            *ngFor="let pas of pasCi"
            [value]="pas"
          >
            {{ pas }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-4">
      <mat-form-field appearance="outline">
        <mat-label>{{ Texts.ciPassport }}</mat-label>
        <input
          type="text"
          [value]="form.value.ciPassport"
          matInput
          disabled
          placeholder=""
        />
      </mat-form-field>
    </div>
    <div class="col-4">
      <mat-form-field appearance="outline">
        <mat-label>{{ Texts.nationality }} </mat-label>
        <mat-select formControlName="nationality" disabled>
          <mat-option (click)="changeCi()" value="V"> Venezolana </mat-option>
          <mat-option (click)="changeCi()" value="E"> Extranjera </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="col-6">
      <mat-form-field appearance="outline">
        <mat-label>{{ Texts.placeOfBirth }}</mat-label>
        <mat-select formControlName="placeOfBirth">
          <mat-option *ngFor="let country of countrys" [value]="country">{{
            country
          }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-6">
      <mat-form-field appearance="outline">
        <mat-label>{{ Texts.birthdate }}</mat-label>
        <input
          type="date"
          formControlName="birthdate"
          matInput
          placeholder="31/12/2021"
        />
      </mat-form-field>
    </div>
    <div class="col-4">
      <mat-form-field appearance="outline">
        <mat-label>{{ Texts.gender }} </mat-label>
        <mat-select formControlName="gender">
          <mat-option value="m"> Masculino </mat-option>
          <mat-option value="f"> Femenino </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="col-8">
      <mat-form-field appearance="outline">
        <mat-label>{{ Texts.direction }}</mat-label>
        <input
          type="text"
          formControlName="direction"
          matInput
          placeholder="Avenida / Calle / Casa - Edificio / Piso - Nivel / Apartamento - Local."
        />
      </mat-form-field>
    </div>
    <div class="col-4">
      <mat-form-field appearance="outline">
        <mat-label>{{ Texts.state }}</mat-label>
        <input
          type="text"
          formControlName="state"
          *ngIf="form.value.placeOfBirth != 'VENEZUELA'"
          matInput
          placeholder="Estado"
        />
        <mat-select
          (ngModelChange)="changeEstado($event)"
          formControlName="state"
          *ngIf="form.value.placeOfBirth == 'VENEZUELA'"
          placeholder="Estado"
          (ngModelChange)="changeEstado($event)"
        >
          <mat-option *ngFor="let estad of est" [value]="estad">
            {{ estad }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-4">
      <mat-form-field appearance="outline">
        <mat-label>{{ Texts.municipality }}</mat-label>
        <input
          type="text"
          formControlName="municipality"
          *ngIf="form.value.placeOfBirth != 'VENEZUELA'"
          matInput
          placeholder="Municipio"
        />
        <mat-select
          (ngModelChange)="changeMunicipio($event)"
          [disabled]="!mun"
          formControlName="municipality"
          *ngIf="form.value.placeOfBirth == 'VENEZUELA'"
          placeholder="Municipio"
        >
          <mat-option *ngFor="let muni of mun" [value]="muni">
            {{ muni }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-4">
      <mat-form-field appearance="outline">
        <mat-label>{{ Texts.parish }}</mat-label>
        <input
          type="text"
          formControlName="parish"
          *ngIf="form.value.placeOfBirth != 'VENEZUELA'"
          matInput
          placeholder="Parroquia"
        />
        <mat-select
          [disabled]="!parr"
          formControlName="parish"
          *ngIf="form.value.placeOfBirth == 'VENEZUELA'"
          placeholder="Parroquia"
        >
          <mat-option *ngFor="let parro of parr" [value]="parro">
            {{ parro }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-4">
      <mat-form-field appearance="outline">
        <mat-label>{{ Texts.phone1 }}</mat-label>
        <input
          type="text"
          formControlName="phone1"
          matInput
          placeholder="(0212) 462-35-32."
        />
      </mat-form-field>
    </div>
    <div class="col-4">
      <mat-form-field appearance="outline">
        <mat-label>{{ Texts.phone2 }}</mat-label>
        <input
          type="text"
          formControlName="phone2"
          matInput
          placeholder="(0426) 462-35-32"
        />
      </mat-form-field>
    </div>

    <div class="col-12">
      <mat-form-field appearance="outline">
        <mat-label>{{ Texts.occupation }}</mat-label>
        <!-- <input
          type="text"
          formControlName="occupation"
          matInput
          placeholder="Elaboración de productos alimenticios."
        /> -->
        <mat-select formControlName="occupation">
          <mat-option *ngFor="let oc of occupatio" [value]="oc">{{
            oc
          }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-12">
      <mat-form-field appearance="outline">
        <mat-label>{{ Texts.economicActivity }}</mat-label>
        <!-- <input
          type="text"
          formControlName="economicActivity"
          matInput
          placeholder="Elaboración de productos alimenticios."
        /> -->
        <mat-select formControlName="economicActivity">
          <mat-option *ngFor="let act of activity" [value]="act">{{
            act
          }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-12">
      <mat-form-field appearance="outline">
        <mat-label>{{ Texts.specificActivity }}</mat-label>
        <input
          type="text"
          formControlName="specificActivity"
          matInput
          placeholder="Elaboración y distribución de pastas alimenticias."
        />
      </mat-form-field>
    </div>
    <div class="col-12">
      <p>
        <b>{{ Texts.institutionReportingClient }}</b>
      </p>
      <mat-radio-group
        aria-label="Select an option"
        formControlName="institutionReportingClient"
      >
        <mat-radio-button class="primary-radiobutton" [value]="true"
          >Si (cuando la persona mantiene algún instrumento o producto en la
          institución reportante).
        </mat-radio-button>
        <mat-radio-button class="primary-radiobutton" [value]="false"
          >No (cuando la persona no posee ningún producto o instrumento en la
          institución reportante).
        </mat-radio-button>
      </mat-radio-group>
    </div>
    <div class="col-12">
      <p>
        <b>{{ Texts.employmentRelationship }}</b>
      </p>
      <mat-radio-group
        aria-label="Select an option"
        formControlName="employmentRelationship"
      >
        <mat-radio-button class="primary-radiobutton" [value]="true"
          >Si (en caso de existir relación laboral entre la persona reportada y
          el sujeto obligado que genera el reporte).
        </mat-radio-button>
        <mat-radio-button class="primary-radiobutton" [value]="false"
          >No (cuando la persona reportada no mantenga relación laboral con el
          sujeto obligado reportante).
        </mat-radio-button>
      </mat-radio-group>
    </div>
    <!-- <div class="col-12">
      <p>
        <b>{{ Texts.institutionClientReportingClient }}</b>
      </p>
      <mat-radio-group
        aria-label="Select an option"
        formControlName="institutionClientReportingClient"
      >
        <mat-radio-button class="primary-radiobutton" [value]="true"
          >Si.
        </mat-radio-button>
        <mat-radio-button class="primary-radiobutton" [value]="false"
          >No.
        </mat-radio-button>
      </mat-radio-group>
    </div> -->
  </div>
</form>
